<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body ">
                        <!-- <h3>{{ selected_user.name }}</h3> -->
                        <b-button @click="navigationToUserList()" variant="primary " size="sm" type="button" class="btn btn-primary">
                            <i class="mdi mdi-arrow-left mr-1"> </i> Back
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- {{ permissions_ids }}
        {{ selectAllTracker }} -->
        <div v-if="user_permissions">
            <div v-for="permission_groups in localPermissions" :key="permission_groups.group" class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <!-- <h5 @click="selectAll(permission_groups.group)" class="d-flex header-hover-pointer">
                                {{ permission_groups.group }}
                            </h5> -->

                            <div @click="selectAll(permission_groups.group)" class="d-flex header-hover-pointer">
                                <h5 class="">
                                    {{ permission_groups.group }}
                                </h5>
                                <span class="h5-tag ml-1">{{ textCheck(permission_groups.group) }}</span>
                            </div>

                            <!-- <b-container class="mb-3 ml-0"> -->
                            <b-row cols-sm="2" cols-md="4" cols-lg="5" class="">
                                <b-col v-for="permission in permission_groups.permissions" :key="permission.id" class="mt-4 remove-user-select"
                                    ><b-form-checkbox
                                        @change="onChange(permission.id)"
                                        :checked="permission.selected"
                                        unchecked-value="false"
                                        value="1"
                                        >{{ permission.display_name }}</b-form-checkbox
                                    ></b-col
                                >
                            </b-row>
                            <!-- </b-container> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body d-flex justify-content-around">
                            <b-button @click="savePermissions" variant="primary">Update User Permissions</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { userAdministrationComputed, userAdministrationMethods, adminComputed, adminMethods } from "@/state/helpers";
//eslint-disable-next-line
import { cloneDeep } from "lodash";
import Swal from "sweetalert2";

export default {
    data: () => ({
        userId: null,
        localPermissions: [],
        selectAllTracker: [],
    }),
    computed: {
        ...userAdministrationComputed,
        ...adminComputed,
        // userPermissions_data() {
        //     return cloneDeep(this.user_permissions);
        // },
    },
    methods: {
        ...userAdministrationMethods,
        ...adminMethods,
        textCheck(text) {
            const index = this.selectAllTracker.indexOf(text);

            if (index === -1) {
                return "(select all)";
            } else {
                return "(unselect all)";
            }
        },
        navigationToUserList() {
            this.$router.push({
                path: `/user-administration`,
            });
        },
        selectAll(groupName) {
            const index = this.selectAllTracker.indexOf(groupName);

            if (index === -1) {
                // If 5 is not in the array, push it
                this.selectAllTracker.push(groupName);

                this.localPermissions = this.localPermissions.map((grouped) => {
                    //eslint-disable-next-line
                    let obj = {
                        group: grouped.group,
                        permissions: grouped.permissions,
                    };

                    if (obj.group == groupName) {
                        //eslint-disable-next-line
                        obj.permissions = obj.permissions.map((permission) => {
                            //first remvoe it
                            this.removePermissionsIds(permission.id);
                            //then add it
                            this.updatedPermissionsIds(permission.id);
                            return { ...permission, selected: 1 };
                        });
                    }

                    return obj;
                });
            } else {
                this.localPermissions = this.localPermissions.map((grouped) => {
                    //eslint-disable-next-line
                    let obj = {
                        group: grouped.group,
                        permissions: grouped.permissions,
                    };

                    if (obj.group == groupName) {
                        //eslint-disable-next-line
                        obj.permissions = obj.permissions.map((permission) => {
                            this.removePermissionsIds(permission.id);

                            return { ...permission, selected: 0 };
                        });
                    }
                    //remove it from the array

                    return obj;
                });
                // delete this.selectAllTracker[groupName];
                // If 5 is already in the array, remove it
                this.selectAllTracker.splice(index, 1);
            }
        },
        //eslint-disable-next-line
        onChange(id) {
            this.localPermissions = this.localPermissions.map((grouped) => {
                //eslint-disable-next-line
                let obj = {
                    group: grouped.group,
                    permissions: grouped.permissions,
                };
                //eslint-disable-next-line
                obj.permissions = obj.permissions.map((permission) => {
                    //eslint-disable-next-line
                    if (permission.id == id) {
                        let typecast;
                        //jsut returns the opposite of the current .selected boolean value
                        permission.selected == 1 ? (typecast = 0) : (typecast = 1);

                        //set in vuex state
                        this.updatedPermissionsIds(id);
                        //set in lcoal state
                        return { ...permission, selected: typecast };
                    }
                    return { ...permission };
                });

                return obj;
            });
        },

        savePermissions() {
            Swal.fire({
                title: ` Update user permissions `,
                text: `Are you sure??`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    this.saveUsersPermissions({ user_id: this.userId, permission_ids: this.permissions_ids }).then(() => {
                        this.setUserPermissions(this.userId).then(() => {
                            this.localPermissions = this.user_permissions;
                            this.setSelectAllTrackerFirstLoad();
                        });
                        Swal.fire(`Permissions Updated`, "", "success");
                    });
                }
            });
        },
        setSelectAllTrackerFirstLoad() {
            //check to see if all the checks are active
            for (let i = 0; i < this.localPermissions.length; i++) {
                let count = 0;

                for (let k = 0; k < this.localPermissions[i].permissions.length; k++) {
                    if (this.localPermissions[i].permissions[k].selected == 1) {
                        count += 1;
                    }
                }

                if (count == this.localPermissions[i].permissions.length) {
                    this.selectAllTracker.push(this.localPermissions[i].group);
                }
            }
        },
    },
    mounted() {
        this.userId = this.$route.params.user_id;

        this.setUserPermissions(this.userId).then(() => {
            this.localPermissions = [...this.user_permissions];

            this.setSelectAllTrackerFirstLoad();
        });
        //eslint-disable-next-line
        // console.log("the permission is there", this.findPermission(2));

        // let findId = this.permissions.find((findId) => findId.id == 12);
        //eslint-disable-next-line
        // console.log(findId, "permissions", this.permissions);

        //eslint-disable-next-line
        console.log("testing find permission", this.findPermission(2));
    },
};
</script>

<style lang="scss" scoped>
.remove-user-select {
    user-select: none;
}
.header-hover-pointer {
    cursor: pointer;
}
.h5-tag {
    font-size: 10px;
    margin-top: 2.5px;
}
</style>
